import React, {useState} from "react";
import {observer} from "mobx-react";
import DraggableInput from '../Shared/DraggableInput';
import GeneralDialog from "./GeneralDialog";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {useStores} from "../../Hooks";

const CreateMediaProcedureDialog = observer(() => {
    const {modalStore} = useStores();
    const [dragging, setDragging] = useState(false);

    const {title} = modalStore.modalData;

    function closeModal() {
        delete modalStore.modalData.createMediaProceduresMethod;
        delete modalStore.modalData.title;
        modalStore.isCreateMediaProcedureDialogOpen = false;
    }

    async function createProcedures(files) {
        await modalStore.modalData.createMediaProceduresMethod(files);
        closeModal();
    }

    return (
        <GeneralDialog
            openControl='isCreateMediaProcedureDialogOpen'
            className={'blue-dialog dialog big-dialog create-media-procedure-dialog' + (dragging ? ' dragging' : '')}
            title={title || ''}
            body={
                <div className='dragging-container'>
                    <ConditionalComponent if={modalStore.isCreateMediaProcedureDialogOpen}>
                        <DraggableInput
                            onInputSelected={createProcedures}
                            onDragStart={() => setDragging(true)}
                            onDragStop={() => setDragging(false)}
                        />
                    </ConditionalComponent>
                </div>
            }
        />
    );
});

export default CreateMediaProcedureDialog;
